import { LoaderFunction } from "react-router-dom";

import ContentRequests from "@/api/content/content.requests.ts";
import { queryClient } from "@/api/query-client.tsx";
import { CONTENT_KEYS } from "@/hooks/api/content.hooks.ts";
import { lang } from "@/utils/funcs.ts";

export const genresLoader: LoaderFunction = () => {
  const genresCache = queryClient.getQueryData(CONTENT_KEYS.genres(lang, 18));
  if (genresCache) return genresCache;

  return queryClient.fetchInfiniteQuery({
    queryKey: CONTENT_KEYS.genres(lang, 18),
    queryFn: ({ pageParam = 0 }) => ContentRequests.getGenres(18, pageParam * 18),
    initialPageParam: 0,
    staleTime: 1000 * 60 * 60,
  });
};
